import { BaseEditor, Editor, Transforms } from "slate";
import { ReactEditor } from "slate-react";
import { CustomElement } from "../slate";

export interface HeadersEditor extends BaseEditor {
  isHeader1: () => boolean;
  isOrderedHeader1: () => boolean;
  isHeader2: () => boolean;
  isHeader3: () => boolean;
  toggleHeader1: () => void;
  toggleOrderedHeader1: () => void;
  toggleHeader2: () => void;
  toggleHeader3: () => void;
}

const isHeader1 = (editor: Editor) => {
  const [match] = Editor.nodes(editor, {
    match: (n: CustomElement | any) =>
      n.type === "heading" && n.level === 1 && n.isOrdered !== true,
  });
  return !!match;
};

/**
 * @description Wraps the block with a h1 tag.
 *
 * @param {CustomEditor} editor
 */
const toggleHeader1 = (editor: Editor) => {
  const isActive = isHeader1(editor);

  Transforms.setNodes(editor, {
    type: isActive ? "paragraph" : "heading",
    level: 1,
    isOrdered: false,
  });
  ReactEditor.focus(editor);
};

const isOrderedHeader1 = (editor: Editor) => {
  const [match] = Editor.nodes(editor, {
    match: (n: CustomElement | any) =>
      n.type === "heading" && n.level === 1 && n.isOrdered === true,
  });
  return !!match;
};

/**
 * @description Wraps the block with a h1 tag with .unordered class name.
 *
 * @param {CustomEditor} editor
 */
const toggleOrderedHeader1 = (editor: Editor) => {
  const isActive = isOrderedHeader1(editor);

  Transforms.setNodes(editor, {
    type: isActive ? "paragraph" : "heading",
    level: 1,
    isOrdered: true,
  });
  ReactEditor.focus(editor);
};

const isHeader2 = (editor: Editor) => {
  const [match] = Editor.nodes(editor, {
    match: (n: CustomElement | any) => n.type === "heading" && n.level === 2,
  });
  return !!match;
};

/**
 * @description Wraps the block with a h2 tag.
 *
 * @param {CustomEditor} editor
 */
const toggleHeader2 = (editor: Editor) => {
  const isActive = isHeader2(editor);

  Transforms.setNodes(editor, {
    type: isActive ? "paragraph" : "heading",
    level: 2,
  });
  ReactEditor.focus(editor);
};

const isHeader3 = (editor: Editor) => {
  const [match] = Editor.nodes(editor, {
    match: (n: CustomElement | any) => n.type === "heading" && n.level === 3,
  });
  return !!match;
};

/**
 * @description Wraps the block with a h2 tag.
 *
 * @param {CustomEditor} editor
 */
const toggleHeader3 = (editor: Editor) => {
  const isActive = isHeader3(editor);

  Transforms.setNodes(editor, {
    type: isActive ? "paragraph" : "heading",
    level: 3,
  });
  ReactEditor.focus(editor);
};

export const withHeaders = (editor: Editor) => {
  editor.isHeader1 = () => isHeader1(editor);
  editor.isOrderedHeader1 = () => isOrderedHeader1(editor);
  editor.isHeader2 = () => isHeader2(editor);
  editor.isHeader3 = () => isHeader3(editor);
  editor.toggleHeader1 = () => toggleHeader1(editor);
  editor.toggleOrderedHeader1 = () => toggleOrderedHeader1(editor);
  editor.toggleHeader2 = () => toggleHeader2(editor);
  editor.toggleHeader3 = () => toggleHeader3(editor);
  return editor;
};
